import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { DriversForm } from "@/features/dashboard/motoristas/components/DriversForm";

export const Route = createFileRoute("/_private/dashboard/_base/motoristas/cadastrar/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Cadastrar Motorista</DashboardComponents.Title>

      <DriversForm />
    </Stack>
  );
}
